import React from 'react'
import Newsletter from './NewsLetter'
import GetInTouch from './GetInTouch'
import Footer from './Footer'
import Package from './Package'
import PartnerTop from './PartnerTop'
import LMS1 from '../assets/LMS-1.png'
import ProductDes from './ProductDes'
import Productsdiv3 from './Productsdiv3'
import FeaturesGrid from './FeaturesGrid'
import icon1 from '../assets/marketing.png';
import icon2 from '../assets/operation.png';
import icon3 from '../assets/finance.png';
import icon4 from '../assets/automation.png';
import MainFeatures from './MainFeatures';
import mf8 from '../assets/course-tracker.png';
import mf9 from '../assets/study-material-upload.png';
import mf11 from '../assets/one-stop-dashboard.png';
import mf12 from '../assets/mis-reports.png';
import product2 from '../assets/product2.png';


const LearningManagement = () => {
  return (
    <div>
        <PartnerTop largeHeading="WARALS Learning Management System" smallHeading="LMS for all kind of institutes and training organization." image={LMS1}/>
      
      <ProductDes largeHeading="Learning Management Systems (LMS)" para1=" Warals LMS is a powerful learning management system with the features and flexibility to fit your e Learning needs. You can easily create powerful and effective e Learning programs that train, validate, and communicate. Warals LMS is designed to reduce operational complexity and help to achieve the core goal of revenue generation of any Institutes/Training organizations. LMS, as a specialized product is a result of collaborative efforts by our developers and end-users by getting the business requirements. We have developed all the required functions which can help to achieve the desired result with minimal effort and with easy to use interface."/>
           
            <Productsdiv3 largeHeading="Why Warals is Unique in Offering LMS" lightHeading="It is hard to find full-featured offering specific to Institute and Training Organizations which can cover all aspects of a business. It reduces the pain of maintaining different department on the various application and makes life easy of entrepreneurs." imagesrc= {product2}/>
           
            <FeaturesGrid
                features={[
                    {
                        id: 1,
                        title: "Marketing & Sales",
                        description:
                            "Leads Management, Inquiry Follow-ups, Email/SMS Integration for Inquiry Follow-ups, Admissions",
                        icon: icon1,
                    },
                    {
                        id: 2,
                        title: "OPERATIONS",
                        description:
                            "Batch Scheduling, Trainers/Students/Employees Management, Course Tracker, Attendance",
                        icon: icon2,
                    },
                    {
                        id: 3,
                        title: "FINANCE",
                        description:
                            "Fee management and Reminders, Expense Management , Employee Salaries, Financials reports,",
                        icon: icon3,
                    },
                    {
                        id: 4,
                        title: "AUTOMATION",
                        description:
                            "Email and SMS Panel Integration, Auto Assignment of Leads, Auto Email of Reports",
                        icon:icon4,
                    },
                ]}
            />

             <MainFeatures features={[
                 {
                    title: 'Study Material Upload',
                    description: 'Option of uploading Course materials for students',
                    icon: mf9
                },
              
                 {
                    title: 'Course Tracker',
                    description: 'Module wise Course tracker for better scheduling',
                    icon: mf8
                },
                
                 {
                    title: 'One Stop Dashboard',
                    description: 'Informative Dashboard for management decision-making',
                    icon: mf11
                },
                 {
                    title: 'MIS reports',
                    description: 'Various MIS reports exportable in Excel and PDF format',
                    icon: mf12
                }


            ]} />

             <Package
                packages={[
                    {
                        title: 'Free*',
                        buttonText: '*Get A Demo Account',
                        features: [
                            { label: 'Enquiry Module' },
                            { label: 'Enquiry Follow ups' },
                            { label: 'Admissions Management' },
                            { label: 'Course Fee Management' },
                            { label: 'Employee and User Management' },
                            { label: 'MIS Reporting' },
                            { label: 'One Stop Reporting Dashboard' },
                            { label: 'Leads Mass Upload' },
                            { label: 'Student Attendance' },
                            { label: 'Employee Attendance' },
                            { label: 'Study Material Upload' },
                            { label: 'Course Tracker' },
                            { label: 'Utilities - Database Backup' },
                            { label: 'Student Panel' },
                            { label: 'Student Transfer' },
                            { label: 'Basic Accounting Features' }
                        ]
                    },
                    {
                        title: 'Basic',
                        buttonText: 'Get A Quote',
                        features: [
                            { label: 'Enquiry Module' },
                            { label: 'Enquiry Follow ups' },
                            { label: 'Admissions Management' },
                            { label: 'Course Fee Management' },
                            { label: 'Employee and User Management' },
                            { label: 'MIS Reporting' },
                            { label: 'One Stop Reporting Dashboard' },
                            { label: 'Leads Mass Upload', isDisabled:true},
                            { label: 'Student Attendance', isDisabled:true },
                            { label: 'Employee Attendance', isDisabled:true },
                            { label: 'Study Material Upload', isDisabled:true },
                            { label: 'Course Tracker', isDisabled:true },
                            { label: 'Utilities - Database Backup', isDisabled:true },
                            { label: 'Student Panel', isDisabled:true },
                            { label: 'Student Transfer', isDisabled:true },
                            { label: 'Basic Accounting Features', isDisabled:true }
                        ]
                    },
                    {
                        title: 'Medium',
                        buttonText: 'Get A Quote',
                        features: [
                            { label: 'Enquiry Module' },
                            { label: 'Enquiry Follow ups' },
                            { label: 'Admissions Management' },
                            { label: 'Course Fee Management' },
                            { label: 'Employee and User Management' },
                            { label: 'MIS Reporting' },
                            { label: 'One Stop Reporting Dashboard' },
                            { label: 'Leads Mass Upload' },
                            { label: 'Student Attendance' },
                            { label: 'Employee Attendance' },
                            { label: 'Study Material Upload' },
                            { label: 'Course Tracker' },
                            { label: 'Utilities - Database Backup' },
                            { label: 'Student Panel', isDisabled:true },
                            { label: 'Student Transfer', isDisabled:true },
                            { label: 'Basic Accounting Features', isDisabled:true }
                        ]
                    },
                    {
                        title: 'Advance',
                        buttonText: 'Get A Quote',
                        features: [
                            { label: 'Enquiry Module' },
                            { label: 'Enquiry Follow ups' },
                            { label: 'Admissions Management' },
                            { label: 'Course Fee Management' },
                            { label: 'Employee and User Management' },
                            { label: 'MIS Reporting' },
                            { label: 'One Stop Reporting Dashboard' },
                            { label: 'Leads Mass Upload' },
                            { label: 'Student Attendance' },
                            { label: 'Employee Attendance' },
                            { label: 'Study Material Upload' },
                            { label: 'Course Tracker' },
                            { label: 'Utilities - Database Backup' },
                            { label: 'Student Panel' },
                            { label: 'Student Transfer' },
                            { label: 'Basic Accounting Features' }
                        ]
                    },
                   
                ]}
            />
      {/* <Newsletter/> */}
      <GetInTouch/>
      <Footer/>
    </div>
  )
}

export default LearningManagement;
